var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"carousel"},[_c('carousel',{attrs:{"navigationEnabled":true,"navigation-next-label":"","navigation-prev-label":"","paginationEnabled":false,"scrollPerPage":false,"spacePadding":24,"perPageCustom":[
            [322, 1.1],
            [350, 1.2],
            [400, 1.2],
            [500, 1.3],
            [575, 1.7],
            [700, 2.1],
            [768, 1.8],
            [960, 2.1],
            [1024, 2.5],
            [1260, 3.5],
            [1366, 4.1],
            [1480, 4.5],
            [1540, 4.7],
            [1600, 5.1],
            [1920, 5.7],
            [2048, 6.5],
            [2560, 8.1] ]}},_vm._l((_vm.partnerProducts),function(variant,index){return _c('slide',{key:index},[_c('product-card',{attrs:{"id":("fanshop-products-product-tile-anchor" + index),"participationAmount":_vm.getParticipationAmount(variant),"partnerId":variant.product.partnerId,"productImage":_vm.getImage(variant),"productTitle":_vm.getTranslatedStr(variant, 'label', variant.label),"ssuPrice":parseInt(variant.product.sellingPrice, 10),"variantId":variant.id,"redeemableAt":_vm.getRedeemableDate(variant),"variant":variant}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }